module.exports = __webpack_public_path__ + "static/media/unselected.171c813d.svg";